// Copyright © 2022 Move Closer
import { TokenType } from '@d24/demarked';
import { AbstractAdapter } from '../_abstract/adapter';
import { getModuleBase } from '../_helpers/adapter';
import { ModuleDriver } from '../_contracts';
import { initialContent } from './RequestAccess.config';
/**
 * @author Łukasz Sitnicki <lukasz.sitnicki@movecloser.pl>
 */
export class RequestAccessAdapter extends AbstractAdapter {
    objectToToken(object, storage) {
        if (!storage) {
            throw new Error('Argument of storage should be present to [image] module');
        }
        const identifier = typeof object.id !== 'undefined' ? object.id : storage.uniqueKey();
        storage.store(identifier, object.content);
        return {
            content: identifier,
            raw: `#FORM[ id: ${identifier} ]`,
            type: TokenType.Form
        };
    }
    tokenToObject(token, storage) {
        if (!storage) {
            throw new Error('Argument of storage should be present to [image] module');
        }
        const content = storage.retrieve(token.content, initialContent);
        return {
            ...getModuleBase(),
            content,
            driver: ModuleDriver.RequestAccess
        };
    }
}
